// extracted by mini-css-extract-plugin
module.exports = {"root":"ResponsesView_root__30BFZ","resourceLink":"ResponsesView_resourceLink__TBRZZ"};